import React from 'react';

import { Box } from '@mui/material';

import type { AutomaticRefundDetailsProps } from './types';

export default function TourAutomaticRefundDetails({
  customer_full_name,
  reason,
  comment,
  source,
  markCancelled,
  currencyCode,
  totalRefund,
}: AutomaticRefundDetailsProps) {
  return (
    <Box display="grid" gap={2} gridTemplateColumns="1fr 1fr 1fr">
      <Box gridColumn="span 3">
        <h4>Refund Summary</h4>
      </Box>

      <Box>
        <small>Customer Name</small>
      </Box>
      <Box gridColumn="span 2">
        <small>{customer_full_name}</small>
      </Box>

      <Box>
        <small>Refund Category</small>
      </Box>
      <Box gridColumn="span 2">
        <small>{reason}</small>
      </Box>

      <Box>
        <small>Customer's reason</small>
      </Box>
      <Box gridColumn="span 2">
        <small>{comment}</small>
      </Box>

      <Box>
        <small>Source of Fund</small>
      </Box>
      <Box gridColumn="span 2">
        <small>{source}</small>
      </Box>

      <Box>
        <small>Room Cancelled</small>
      </Box>
      <Box gridColumn="span 2">
        <small>{markCancelled}</small>
      </Box>

      <Box>
        <small>
          <b>Customer Refund Amount {currencyCode}</b>
        </small>
      </Box>
      <Box gridColumn="span 2">
        <small>{totalRefund}</small>
      </Box>
    </Box>
  );
}
